

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isMetaMaskExtensionError = (value) => {
    const text = typeof value === "string"
        ? value
        : value?.message || value?.reason?.message || "";
    const source = value?.filename || value?.reason?.stack || value?.stack || "";

    return (
        text.includes("MetaMask") ||
        text.includes("Failed to connect to MetaMask") ||
        source.includes("chrome-extension://nkbihfbeogaeaoehlefnkodbefgpgknn")
    );
};

// Ignore extension-origin MetaMask runtime noise so it does not surface as an app error.
window.addEventListener("error", (event) => {
    if (!isMetaMaskExtensionError(event)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
}, true);

window.addEventListener("unhandledrejection", (event) => {
    if (!isMetaMaskExtensionError(event)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
}, true);

// Apply the saved user theme before React renders so offline/server-down states
// do not flash or fall back to the default theme.
const storedUser = (() => {
    try {
        return JSON.parse(localStorage.getItem("user") || "null");
    } catch (error) {
        return null;
    }
})();
const themeId = (
    (storedUser?.id && localStorage.getItem(`theme_user_${storedUser.id}`))
    || storedUser?.theme
    || localStorage.getItem("theme")
    || "navy"
);
const themeMap = {
    'brand-green': '#14532d',
    'navy': '#001F3F',
    'amber': '#ba6a36',
    'espresso': '#261311',
    'champagne': '#e6c8b7',
    'cognac': '#c3955b',
    'emerald': '#1c3934',
    'teal': '#0f766e',
    'sea-blue': '#0369a1',
    'ruby': '#9f1239',
};
const color = themeMap[themeId] || themeMap["navy"];
document.documentElement.style.setProperty('--color-primary', color);
document.documentElement.style.setProperty('--color-text', '#111');
document.documentElement.style.setProperty('--color-surface', '#f7f7f7');
// Button active state only
const darken = (hex, amt) => {
    // Simple darken function for hex colors
    let col = hex.replace('#', '');
    if (col.length === 3) col = col.split('').map(x => x + x).join('');
    let num = parseInt(col, 16);
    let r = Math.max(0, ((num >> 16) - amt));
    let g = Math.max(0, (((num >> 8) & 0x00FF) - amt));
    let b = Math.max(0, ((num & 0x0000FF) - amt));
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};
document.documentElement.style.setProperty('--color-active', darken(color, 16));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();
